export const HISTORY_HEADER = {
  DATE: 'date',
  PLAN: 'planName',
  PAYMENT_INFO: 'paymentInfo',
  CANCELED_AT: 'canceledAt',
}
